import { UserAuthEntity } from '../auth/authInterfaces';

export const getSubscriptionPlan = (
  user: UserAuthEntity,
  ispName: string | null,
): { label: string; className: string } => {
  let subscriptionStatus;
  if (user?.asrd) {
    subscriptionStatus = {
      label: `${user.asrd} روز تا پایان اشتراک`,
      className: 'remaining-day__' + (user?.asrd! > 0 && user?.asrd! < 7 ? user?.asrd : '7'),
    };
  } else {
    subscriptionStatus = { label: 'بدون اشتراک', className: 'remaining-day__0' };
  }

  return subscriptionStatus;
};
